export interface Comic {
  id: string;
  title: string;
  category: string;
  tags: string[];
  description: string;
  status: "连载中" | "完结";
  views: number;
  likes: number;
  chapters: number;
  update: string;
  hot?: boolean;
  badge?: string;
  cover: string;
}

export interface Category {
  key: string;
  name: string;
  desc: string;
  icon: string;
}

export const categories: Category[] = [
  {
    key: "shadiao",
    name: "沙雕搞笑",
    desc: "专治不开心，笑到合不拢嘴",
    icon: "ri-emotion-laugh-line",
  },
  {
    key: "wulitou",
    name: "无厘头",
    desc: "离谱但上头，剧情完全猜不到",
    icon: "ri-goblet-fill",
  },
  {
    key: "shenzhuanzhe",
    name: "神转折",
    desc: "最后一格永远在打脸",
    icon: "ri-restart-fill",
  },
  {
    key: "naodong",
    name: "脑洞大开",
    desc: "奇思妙想，世界观大胆到飞",
    icon: "ri-lightbulb-flash-fill",
  },
  {
    key: "moxing",
    name: "魔性画风",
    desc: "越看越上瘾的魔性画面",
    icon: "ri-artboard-2-fill",
  },
  {
    key: "qipa",
    name: "奇葩剧情",
    desc: "只有你想不到，没有它画不出",
    icon: "ri-shuffle-fill",
  },
];

export const comics: Comic[] = [
  {
    id: "kaoyan",
    title: "《老板今天又疯了》",
    category: "沙雕搞笑",
    tags: ["职场", "吐槽", "爆笑"],
    description:
      "社畜小白的老板每天都有新花样：今天要为公司改个名，明天要给吉祥物办婚礼。笑点密集，打工人看了直呼内行。",
    status: "连载中",
    views: 986000,
    likes: 62400,
    chapters: 128,
    update: "今天 09:20",
    hot: true,
    badge: "TOP 1",
    cover:
      "https://readdy.ai/api/search-image?query=Silly%20comic%20cover%20of%20a%20mad%20boss%20and%20stressed%20office%20worker%20in%20cartoon%20style%2C%20warm%20orange%20background%2C%20playful%20meme%20comic%20illustration%2C%20bright%20colors%2C%20funny%20expressions&width=600&height=800&seq=comic-kaoyan&orientation=portrait",
  },
  {
    id: "waimai",
    title: "《外卖小哥的逆袭》",
    category: "神转折",
    tags: ["逆袭", "反转", "都市"],
    description:
      "送个外卖也能送到异世界？主角从普通骑手一路逆袭，每话结尾都给你一个意想不到的神转折，笑中带燃。",
    status: "连载中",
    views: 745000,
    likes: 53800,
    chapters: 96,
    update: "今天 08:05",
    hot: true,
    badge: "HOT",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20a%20delivery%20rider%20on%20scooter%20flying%20into%20a%20portal%20in%20cartoon%20style%2C%20warm%20yellow%20background%2C%20silly%20playful%20meme%20comic%20illustration&width=600&height=800&seq=comic-waimai&orientation=portrait",
  },
  {
    id: "shiyou",
    title: "《室友是条咸鱼》",
    category: "无厘头",
    tags: ["日常", "沙雕", "脑洞"],
    description:
      "搬进新家才发现室友不是人——是条货真价实的咸鱼！一人一鱼的无厘头同居日常，离谱中透着温情。",
    status: "连载中",
    views: 612000,
    likes: 41800,
    chapters: 80,
    update: "昨天 23:40",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20comic%20cover%20of%20a%20slacker%20salty%20fish%20roommate%20lying%20on%20sofa%20with%20young%20man%2C%20cartoon%20style%2C%20warm%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-shiyou&orientation=portrait",
  },
  {
    id: "npc",
    title: "《穿越成NPC之后》",
    category: "脑洞大开",
    tags: ["穿越", "游戏", "脑洞"],
    description:
      "一觉醒来成了游戏里只会重复台词的路人NPC。为了不被玩家反复刷，主角硬是把NPC做成了全服顶流。",
    status: "连载中",
    views: 533000,
    likes: 39600,
    chapters: 64,
    update: "昨天 21:10",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20an%20NPC%20character%20in%20a%20fantasy%20game%20holding%20exclamation%20mark%20above%20head%2C%20cartoon%20style%2C%20warm%20teal%20and%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-npc&orientation=portrait",
  },
  {
    id: "mao",
    title: "《猫主子的日常》",
    category: "魔性画风",
    tags: ["宠物", "魔性", "治愈"],
    description:
      "铲屎官视角记录猫主子的迷惑行为：对纸箱发疯、半夜跑酷、把家里当战场的魔性日常，画风有毒，越看越上头。",
    status: "连载中",
    views: 498000,
    likes: 35100,
    chapters: 112,
    update: "昨天 19:30",
    badge: "NEW",
    cover:
      "https://readdy.ai/api/search-image?query=Crazy%20cat%20comic%20cover%20with%20cat%20inside%20cardboard%20box%2C%20dizzy%20spiral%20eyes%2C%20cartoon%20style%2C%20warm%20yellow%20background%2C%20playful%20meme%20comic%20illustration&width=600&height=800&seq=comic-mao&orientation=portrait",
  },
  {
    id: "juben",
    title: "《剧本拿反了》",
    category: "奇葩剧情",
    tags: ["反套路", "搞笑", "脑洞"],
    description:
      "反派想统治世界，结果全员都在认真搞建设；主角想摆烂，却总被命运推着走上人生巅峰。剧本从头到尾都是反的。",
    status: "连载中",
    views: 457000,
    likes: 32000,
    chapters: 72,
    update: "昨天 17:45",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20villain%20and%20hero%20swapped%20script%20papers%20looking%20confused%2C%20cartoon%20style%2C%20warm%20purple%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-juben&orientation=portrait",
  },
  {
    id: "laowang",
    title: "《隔壁老王的金手指》",
    category: "沙雕搞笑",
    tags: ["金手指", "乡村", "爆笑"],
    description:
      "村里老王随手捡到个金手指，从此人生开挂。但每次开挂的姿势都过于清奇，笑点密度拉满，停不下来。",
    status: "连载中",
    views: 398000,
    likes: 27800,
    chapters: 55,
    update: "前天 22:10",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20happy%20village%20uncle%20holding%20golden%20finger%20artifact%2C%20cartoon%20style%2C%20warm%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-laowang&orientation=portrait",
  },
  {
    id: "fandang",
    title: "《反派今天也很努力》",
    category: "神转折",
    tags: ["反派", "反转", "励志"],
    description:
      "史上最努力的反派：早上做计划、中午搞破坏、晚上复盘。可每次计划都被主角的骚操作打乱，结局总是神反转。",
    status: "连载中",
    views: 366000,
    likes: 24100,
    chapters: 48,
    update: "前天 20:25",
    badge: "HOT",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20determined%20villain%20wearing%20suit%20and%20writing%20plans%20on%20board%2C%20cartoon%20style%2C%20warm%20purple%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-fandang&orientation=portrait",
  },
  {
    id: "xiuxian",
    title: "《修仙先从打工开始》",
    category: "无厘头",
    tags: ["修仙", "职场", "沙雕"],
    description:
      "修仙也要996？主角拜入宗门第一天就被安排去炼丹厂流水线。一边修炼一边打工的无厘头修仙日常，离谱又上头。",
    status: "完结",
    views: 329000,
    likes: 22800,
    chapters: 130,
    update: "上周 18:00",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20cultivator%20wearing%20modern%20work%20uniform%20at%20potion%20factory%20assembly%20line%2C%20cartoon%20style%2C%20warm%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-xiuxian&orientation=portrait",
  },
  {
    id: "zhangyu",
    title: "《我是只章鱼精》",
    category: "脑洞大开",
    tags: ["妖怪", "脑洞", "治愈"],
    description:
      "上岸打工的章鱼精，八只手同时开八份工。别人卷不动的活它全包了，脑洞清奇又治愈，越看越有味道。",
    status: "连载中",
    views: 298000,
    likes: 19500,
    chapters: 40,
    update: "6月30日",
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20comic%20cover%20of%20an%20octopus%20spirit%20with%20multiple%20arms%20holding%20different%20tools%2C%20cartoon%20style%2C%20warm%20turquoise%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-zhangyu&orientation=portrait",
  },
  {
    id: "shechu",
    title: "《社畜的自我修养》",
    category: "魔性画风",
    tags: ["职场", "魔性", "扎心"],
    description:
      "从摸鱼到内卷，从被PUA到反向输出，打工人的魔性生存指南。画面有毒、台词扎心，看一次笑一次又心疼一次。",
    status: "连载中",
    views: 275000,
    likes: 18300,
    chapters: 66,
    update: "6月28日",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20office%20worker%20with%20two%20faces%20smiling%20and%20crying%2C%20cartoon%20style%2C%20warm%20yellow%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-shechu&orientation=portrait",
  },
  {
    id: "baohuke",
    title: "《地球保卫科》",
    category: "奇葩剧情",
    tags: ["科幻", "沙雕", "脑洞"],
    description:
      "地球成立了一个保卫科，每天处理的外星入侵都透着沙雕气息。正经部门干的全是不正经的活，奇葩到离谱。",
    status: "连载中",
    views: 244000,
    likes: 16100,
    chapters: 34,
    update: "6月25日",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20silly%20alien%20invasion%20and%20earth%20defense%20team%20in%20office%2C%20cartoon%20style%2C%20warm%20teal%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-baohuke&orientation=portrait",
  },
  {
    id: "chuanyue",
    title: "《穿成门卫大爷》",
    category: "神转折",
    tags: ["穿越", "身份", "反转"],
    description:
      "穿成小区门卫大爷，本以为平平无奇，结果整个小区住的全是大佬。主角凭一双火眼金睛，在保安室写下了传奇。",
    status: "完结",
    views: 218000,
    likes: 14800,
    chapters: 88,
    update: "6月20日",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20security%20guard%20grandpa%20at%20community%20gate%20with%20mysterious%20aura%2C%20cartoon%20style%2C%20warm%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-chuanyue&orientation=portrait",
  },
  {
    id: "zhifan",
    title: "《被系统绑定后》",
    category: "脑洞大开",
    tags: ["系统", "沙雕", "金手指"],
    description:
      "被一个沙雕系统绑定的倒霉蛋，系统任务一个比一个离谱：让主角去给鲨鱼做美甲、给冰箱讲睡前故事……",
    status: "连载中",
    views: 196000,
    likes: 13200,
    chapters: 29,
    update: "6月18日",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20confused%20person%20with%20holographic%20system%20window%20and%20silly%20tasks%2C%20cartoon%20style%2C%20warm%20purple%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-zhifan&orientation=portrait",
  },
  {
    id: "gongdi",
    title: "《工地的快乐时光》",
    category: "沙雕搞笑",
    tags: ["工地", "日常", "爆笑"],
    description:
      "一帮工地老哥的沙雕日常：比谁搬砖姿势帅、给挖掘机取外号、把工地板房活成喜剧现场，笑点永不缺席。",
    status: "完结",
    views: 168000,
    likes: 11500,
    chapters: 60,
    update: "6月12日",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20happy%20construction%20workers%20laughing%20at%20building%20site%2C%20cartoon%20style%2C%20warm%20yellow%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-gongdi&orientation=portrait",
  },
  {
    id: "jiuxing",
    title: "《酒醒之后是社死》",
    category: "魔性画风",
    tags: ["日常", "社死", "魔性"],
    description:
      "每次喝断片后醒来，都是大型社死现场。主角一边尴尬抠地，一边收拾自己搞出来的烂摊子，画面有毒。",
    status: "连载中",
    views: 145000,
    likes: 9800,
    chapters: 22,
    update: "6月8日",
    badge: "NEW",
    cover:
      "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20embarrassed%20person%20waking%20up%20after%20party%20with%20cringe%20face%2C%20cartoon%20style%2C%20warm%20purple%20orange%20background%2C%20playful%20silly%20meme%20illustration&width=600&height=800&seq=comic-jiuxing&orientation=portrait",
  },
];